import React from "react";
import MediaCard from "../mediacard/MediaCard";
import evote from "../../images/projects/evote.jpg";
import catering from "../../images/projects/catering.jpg";
import nscam from "../../images/projects/nscam.png";

const PROJECTS = [
  {
    to: "/digital-forensics-homelab/",
    icon: "fa-server",
    iconLabel: "HomeLab",
    tagline: "Self-Hosted AD + Forensics Range",
    title: "Digital Forensics HomeLab",
    description:
      "A KVM/virt-manager lab on Ubuntu: a pfSense firewall segmenting the network, a Windows Server domain controller, two domain-joined Windows clients running a DC-pushed logon script, a Kali Linux box, and a CAINE live-boot machine for forensic work. Setup is done. Write-ups and exercises are still in progress.",
    badge: "Work In Progress",
  },
  {
    to: "/cases/",
    icon: "fa-folder-open",
    iconLabel: "Cases",
    tagline: "Worked Investigations",
    title: "Digital Forensics Cases",
    description:
      "Full case files from my home lab: the scenario, evidence handling, analysis, and the paperwork. Each case includes an incident report, chain of custody form, and hash list. Case 001 is planned.",
    badge: "Coming Soon",
  },
  {
    href: "//jntkevote.netlify.app/",
    image: evote,
    tagline: "Voting With Blockchain",
    title: "E-Voting Capstone Project",
    description:
      "By using Blockchain technology on a public ledger, it allows votes to be more secured on a web platform. This application prohibits voter fraud, voter traceability all while allowing a fair and just democratic process void of interferences.",
  },
  {
    href: "//andreasclassic.netlify.app/",
    image: catering,
    tagline: "Local Catering Service",
    title: "Andrea's Classic Catering",
    description:
      "Being the lead web developer on this project, it was commissioned to create a page for a Western Catering Service. This project is currently continuous.",
  },
  {
    href: "//nscam.netlify.app/",
    image: nscam,
    tagline: "Portland Touring Company",
    title: "NSCAM Tours",
    description:
      "This project was curated to create a web application for clients to use for information regarding the Nature Scenic Cultural Adventurous Movement Tours company in Portland. This project is continuous.",
  },
];

function projects() {
  return (
    <section id="projects">
      <div className="projects main">
        <div className="projects-header">
          <h1 className="section-title">Projects</h1>
        </div>
        <div className="media-card-list">
          {PROJECTS.map((project, index) => (
            <MediaCard key={project.title} {...project} flipped={index % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default projects;
